import React from 'react';
import { Row, Col, Navbar, FormGroup, FormControl, Alert, Well } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

export default class SearchEpcComponent extends React.Component {

	componentDidMount() {
	}

	componentWillUnmount() {
		this.props.cleanAlert();
	}

	handleSearchEpc(searchEpcInput) {
		this.props.searchEpc(searchEpcInput);
	}

	render() {

		let alertDiv = null;
		if (this.props.alertStyle || this.props.alertMessage) {
			alertDiv = (
				<Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
					{this.props.alertMessage}
				</Alert>
			);
		}

		return (
			<div>
				<Row>
					<Col style={{ marginTop: 10 }}>
						{alertDiv}
					</Col>
				</Row>
				<Row>
					<Col>
						<div style={{ textAlign: 'left' }}>
							<Navbar.Form>
								<Row style={{ marginLeft: -15, marginRight: -15 }}>
									<Col xs={12}>
									<FormGroup>
											<Typeahead
												onChange={(event) => {}}
												selected={[{ label: '2017', value: '2017' }]}
												options={[{ label: '2017', value: '2017' }]}
												disabled={true}
											/>
										</FormGroup>
										{' '}
										<FormGroup>
											<FormControl type="text" placeholder='請輸入疑似有問題EPC' inputRef={ref => { this.searchEpcInput = ref; }} tabIndex="10" size="25"
												onKeyDown={(event) => {
													// keyCode = 13 => eneter 鍵
													if (event.keyCode === 13) {
														this.handleSearchEpc(this.searchEpcInput.value);
													}
												}} />
										</FormGroup>
										<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
											this.handleSearchEpc(this.searchEpcInput.value);
										}} tabIndex="11" />
									</Col>
								</Row>
							</Navbar.Form>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
					{this.props.searchCheckResult}
					</Col>
				</Row>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/SearchEpcCheckComponent.jsx